<template>
  <el-container>
    <Asids
      v-bind:mainNavData="mainNavData"
      @chengeMenuItem="chengeMenuItem"
    ></Asids>
    <el-main>
      <div class="main-body">
        <div class="main-body-left">
          <div class="top-nav">
            <TopBreadcrumb v-if="isTopBreadcrumb"></TopBreadcrumb>
            <div class="top-nav_text">印象普陀会员分销结算系统v1.0</div>
            <!-- <div>打开抽屉</div> -->
          </div>
          <div class="app-inner">
            <router-view />
          </div>
        </div>
        <div class="main-body-right" v-show="false">
          <div class="right-body">
            <el-card class="user-card">
              <div style="padding: 14px;">
                <span
                  ><strong style="font-size: 20px;">好吃的汉堡</strong></span
                >
                <div class="bottom clearfix">
                  <time class="time">{{ "currentDate " }}</time>
                  <el-button type="text" class="button">操作按钮</el-button>
                </div>
              </div>
            </el-card>
          </div>

          <div class="right-foot"></div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import Asids from "../components/aside.vue";
import TopBreadcrumb from "../components/topBreadcrumb.vue";
export default {
  name: "index.vue",
  data() {
    return {
      isTopBreadcrumb: true,
      mainNavData: [],
      a: 0,
      b: 1,
      show: true,
      isRouterAlive: true,
      menuBtn: [],
      bodyRight: true
    };
  },
  created: function() {
    this.getMenuList();
  },
  beforeMount: function() {},
  mounted: function() {
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
        if (document.body.clientWidth < 1200) {
          this.bodyRight = false;
        } else {
          this.bodyRight = true;
        }
      })();
    };
  },
  beforeUpdate: function() {
    this.menuBtn = this.getRouteInfo(
      JSON.parse(sessionStorage.getItem("auth"))
    );
    sessionStorage.setItem("menuBtn", JSON.stringify(this.menuBtn));
  },
  components: {
    Asids,
    TopBreadcrumb
  },
  methods: {
    getRouteInfo(menulist) {
      let url = this.$route.path;

      for (let i = 0; i < menulist.length; i++) {
        if (url == menulist[i].route) {
          return menulist[i];
        } else if (menulist[i].childrens) {
          if (this.getRouteInfo(menulist[i].childrens))
            return this.getRouteInfo(menulist[i].childrens);
        }
      }
      return null;
    },
    chengeMenuItem(e) {
      this.isTopBreadcrumb = true;
      if (e == "/dashboard") {
        this.isTopBreadcrumb = false;
      }
    },
    getMenuList() {
      let menulist = JSON.parse(sessionStorage.getItem("auth"));
      this.mainNavData = this.filterMenuList(menulist);
    },
    filterMenuList(list) {
      // debugger
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        if (item.menu_type == "F") {
          list.splice(i, 1);
          i--;
        } else if (item.menu_type == "C") {
          // delete list[i].children
          list[i].children = null;
        } else if (item.menu_type == "M" && item.children) {
          this.filterMenuList(item.children);
        }
      }

      // return this.deletaNullMune(list);
      return list;
    },
    deletaNullMune(list) {
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        if (item.type == 3 && item.childrens) {
          if (item.childrens.length > 0) {
            this.deletaNullMune(item.childrens);
          } else {
            list.splice(i, 1);
            i--;
          }
        }
      }
      return list;
    }
  }
};
</script>

<style scoped lang="scss">
@media (min-width: 1200px) {
}
.main-body {
  display: flex;
  .main-body-left {
    width: 100%;
    min-width: 80%;
    .top-nav {
      display: flex;
      background-color: #fff;
      color: #000;
      height: 56px;
      &_text {
        width: 240px;
        font-size: 14px;
        color: #97a8be;
        text-align: right;
        margin-right: 15px;
      }
    }
  }
  .main-body-right {
    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 0px;
    right: 0;
    height: calc(100vh - 60px);
    width: 20%;
    border-left: 1px solid #ebedf0;
    .right-title {
      height: 55px;
      border-bottom: 1px solid #ebedf0;
      width: 100%;
      background-color: #f0f;
    }
    .right-body {
      height: calc(100% - 100px);
      background-color: #0ff;
    }
    .right-foot {
      background-color: #0f0;
      height: 100px;
    }
  }
}
@media (max-width: 1200px) {
  .main-body-left {
    width: 100%;
  }
  .main-body-right {
    display: block;
    // overflow: block;
  }
}
.el-container {
  background: #f7f8fa;
  height: 100%;
  .el-main {
    padding: 0;
    .app-inner {
      margin: 10px;
      // margin-bottom: 0;
      padding: 10px;
      min-width: 750px;
      min-height: 500px;
      -webkit-box-shadow: none;
      box-shadow: none;
      background-color: #fff;
    }
  }
}
</style>
